/* Copyright 2013 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "dojo/topic",
    "dijit/registry",
    "MW/toolstrip/constants/TypeConstants",
    "MW/toolstrip/hashes/PeerNodeWidgetPropertiesHash",
    "MW/toolstrip/menu/PopupList",
    "MW/toolstrip/menu/ListItem",
    "MW/toolstrip/qab/QABDropDownButton"
], function (declare, topic, registry, TypeConstants, PeerNodeWidgetPropertiesHash, PopupList, ListItem, QABDropDownButton) {

    return declare([QABDropDownButton], {

        postCreate: function () {
            // g1607564
            // Set the "text" property since it will be used to show the label in Toolstrip.js
            this.text = this[PeerNodeWidgetPropertiesHash[TypeConstants.QAB_FLOATING_PANE_DOCK]["text"]];

            this.inherited(arguments);

            // Tell mw-dialog-dialog/FloatingPane.js to update it's reference to dockTo widget
            topic.publish("/floatingPaneDockUpdate", {newWidget: this});

            // Reuse the dockDropDownMenu if it already exists
            if (registry.byId("dockDropDownMenu")) {
                this._popupList = registry.byId("dockDropDownMenu");
            } else {
                this._popupList = new PopupList({id: "dockDropDownMenu"});
            }

            this.set("menuId", "dockDropDownMenu");
        },

        addItem: function (item) {
            var menuItem = new ListItem({
                guiId: item.id,
                text: this._getTitle(item)
            });

            if (!item.hasQABWatches) {
                var that = this;

                // Update menu item label when floatingpane module title changes
                item.watch("title", function () {
                    var menuItem = that._findMenuItemForGuiId(item.id);
                    if (menuItem) {
                        menuItem.set("text", that._getTitle(item));
                    }
                });

                // Add/Remove menu item when floatingpane module class changes
                item.watch("class", function () {
                    var menuItem = that._findMenuItemForGuiId(item.id);
                    if (that._isItemHidden(item)) {
                        if (menuItem) {
                            that.removeItem(item);
                        }
                    } else {
                        if (!menuItem) {
                            that.addItem(item);
                        }
                    }
                });

                item.hasQABWatches = true;
            }

            menuItem.on("click", function () {
                item.show();
                item.bringToTop();
            });

            if (!this._isItemHidden(item)) {
                this._popupList.addChild(menuItem);
            }
            this._toggleSelectDisplayAndReset();
        },

        _getTitle: function (item) {
            var title = item.title;
            title = (title && title.trim) ? title.trim() : title;
            return (title && title.length > 0) ? title : "(Untitled)";
        },

        _isItemHidden: function (item) {
            if (item.class) {
                return item.class.indexOf("visibilityHidden") !== -1;
            }
            return false;
        },

        // Given a guiId from the FloatingPane it returns the corresponding menu item in the dock dropdown menu
        _findMenuItemForGuiId: function (guiId) {
            var result = null;
            this._popupList.getChildren().some(function (menuItem) {
                result = menuItem;
                return menuItem.guiId === guiId;
            });
            return result;
        },

        removeItem: function (item) {
            var menuItem = this._findMenuItemForGuiId(item.id);
            if (menuItem) {
                this._popupList.removeChild(menuItem);
                menuItem.destroyRecursive();
            }

            // The disabled state of the button only needs to be updated if it hasn't already been destroyed
            if (!this._destroyed) {
                this._toggleSelectDisplayAndReset();
            }
        },

        // Make sure the button starts up with the correct disabled state depending on the presence of any menu items
        startup: function () {
            this.inherited(arguments);
            this._toggleSelectDisplayAndReset();
        },

        _toggleSelectDisplayAndReset: function () {
            if (this._popupList.getChildren().length > 0) {
                this.set("disabled", false);
            } else {
                this.set("disabled", true);
            }
        },

        _positionDock: function () {
        }
    });
});